module.exports = __webpack_public_path__ + "d69a3344683983f473d2cc100b8ff5b5.pdf";